/**
 * useRunSelection - Hook for run selection logic
 * 
 * Responsibility: Selecting and deselecting runs
 * - Select a run (triggers detail fetching)
 * - Clear selection
 * 
 * Depends on: useRunsStore (receives store methods as parameters)
 */
import { useCallback } from 'react';

const useRunSelection = ({ setSelectedRunId, fetchRunDetails }) => {
  
  // Select a run - sets the ID and fetches populated details
  const selectRun = useCallback(async (runId) => {
    setSelectedRunId(runId);
    if (runId) {
      await fetchRunDetails(runId);
    }
  }, [setSelectedRunId, fetchRunDetails]);

  return {
    selectRun
  };
};

export default useRunSelection;
